module.exports = __webpack_public_path__ + "img/zyy_btn.a2226321.png";